import React from 'react';

import { Header, Footer } from './components';
import { ApolloProvider, NormalizedCacheObject } from '@apollo/client';
import { useApollo } from '@/helpers/apollo';

type Props = {
  children: React.ReactNode;
  initialApolloState?: NormalizedCacheObject;
};

export const AppFrame = ({ initialApolloState = {}, children }: Props) => {
  const apolloClient = useApollo(initialApolloState);

  return (
    <ApolloProvider client={apolloClient}>
      <div className="flex min-h-screen flex-col bg-gray-100 font-sans">
        <Header />

        <main className="mx-auto w-full flex-grow pt-6 pb-8 sm:px-4">{children}</main>

        <Footer />
      </div>
    </ApolloProvider>
  );
};

export default AppFrame;
